import React from 'react';
import PropTypes from 'prop-types';
import useIsWideScreen from '@medflex/hooks/useIsWideScreen';
import ActionSheet from '../ActionSheet';
import PopupMenu from '../PopupMenu';

const ContextMenuMenu = ({ children, closeButtonLabel, ...props }) => {
  const isPopupMenu = useIsWideScreen();

  const Menu = isPopupMenu ? PopupMenu.Menu : ActionSheet.Menu;
  const menuProps = {
    ...props,
    ...(isPopupMenu ? {} : { closeButtonLabel }),
  };

  return <Menu {...menuProps}>{children}</Menu>;
};

ContextMenuMenu.propTypes = {
  children: PropTypes.node,
  closeButtonLabel: PropTypes.string,
};

export default ContextMenuMenu;
